import { Page, Text, View } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import { formatSerialNumber } from "../constants/serialNumbers";


const contractDefinitions = [
  {
    title: "Agreed Purposes",
    content:
      "refers to the contents of this Contract which the Parties agree to.",
  },
  {
    title: "Business Day",
    content:
      "refers to a day (other than a Saturday, Sunday or public holiday in the United Kingdom) when banks in the City of London are generally open for business.",
  },
  {
    title: "Clients",
    content:
      "refers to any person who has taken up or intends to take up plans or to whom products have been offered or provided and any person prospectively or potentially falling within any of the foregoing categories.",
  },
  {
    title: "Company",
    content:
      "refers to Rosemount Financial Solutions (IFA) Ltd (Company Registration Number 05668905), whose registered office is at Rosemount House, 2-4 Chequers Road, Basingstoke, RG21 7PU, United Kingdom.",
  },
  {
    title: "Data Protection Regulation",
    content:
      " (i) unless and until the GDPR is no longer directly applicable in the UK, the General Data Protection Regulation ((EU) 2016/679) and any national implementing laws, regulations and secondary legislation, as amended or updated from time to time, in the UK and then (ii) any successor legislation to the GDPR or the Data Protection Act 2018. ",
  },
  {
    title: "Employees",
    content: "means persons employed by the Appointed Representative.",
  },
  {
    title: "FCA",
    content:
      "means the Financial Conduct Authority of 12 Endeavour Square, London, E20 1JN.",
  },
  {
    title: "Intellectual Property",
    content:
      "refers to intangible property that is the result of creativity, such as patents, copyrights, etc.",
  },
  {
    title: "Parties",
    content:
      "refers to the parties involved in this Contract, namely the Appointed Representative and the Company.means together the Company and the Appointed Representative being the Parties to this Contract",
  },
  {
    title: "Permitted Recipients",
    content:
      "refers to those parties referred to in this Contract who have the appropriate permissions to access and store client data.",
  },
  {
    title: "Product Provider",
    content:
      "refers to sellers of those financial products that are allowed under the supervision of the Company.",
  },
  {
    title: "Sales Activities",
    content:
      "refers to any activity by the Appointed Representative which includes procuring Clients through any means.",
  },
  {
    title: "Services",
    content:
      "means the provision of financial services to Clients including advice in relation to pensions, mortgages, investments, life assurance, wealth management and associated matters.",
  },
];

const Interpretation = ({ serialNumber = 2 }) => {
     const styles = ContractStyles();
  return (
    <View style={[styles.flexColumn, styles.gap_sm]}>
      <ContractListItem
        id="interpretation"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        Interpretation
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_sm,]}>
        <ContractListItem
          marker=""
          markerWidth={0}
          styles={styles}
          textStyle={styles.buttonTextSmall}
        >
          The following definitions shall apply in this Contract:
        </ContractListItem>

        <View style={[styles.flexColumn, styles.gap_sm,]}>
          {contractDefinitions.map(({ title, content }) => (
            <ContractListItem
              key={title}
              marker=""
              markerWidth={0}
              styles={styles}
              textStyle={styles.buttonTextSmall}
            >
              <Text style={styles.labelSmallSemibold}>“{title}”</Text> {content}
            </ContractListItem>
          ))}
        </View>
      </View>
    </View>
  );
};

export default Interpretation;
